<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="d-flex flex-row title-line">
  <well-page-title
    title="{{'company.subscription-type.subscription.list.title' | translate}} "></well-page-title>

  <div class="button-mt mr-md" style="display: flex">
    <button pButton type="button" class="p-button-outlined"
            [label]="'company.subscription-type.add' | translate"
            icon="ui-icon-add" (click)="addNew()" data-testid="add-new-btn"></button>
  </div>
</div>

<p-dialog header="{{'company.subscription-type.subscription.detail' | translate}}"
          [(visible)]="newSubscription"
          [responsive]="true"
          [style]="{width: '900px'}"
          [modal]="true"
          [closable]="true">

  <well-new-subscription [subscriptionTypeUuid]="subscriptionTypeUuid"
                         (close)="hideNewInputs(); list.update()"></well-new-subscription>

</p-dialog>

<div class="row">
  <well-subscriptions-list #list [subscriptionTypeUuid]="subscriptionTypeUuid"></well-subscriptions-list>
</div>




